import { ContactRequest } from '../../../../services/contactRequestServices/types';

export const CONTACT_REQUEST_ACTION_STARTS = 'CONTACT_REQUEST_ACTION_STARTS';
export const CONTACT_REQUEST_ACTION_ERRORS = 'CONTACT_REQUEST_ACTION_ERRORS';
export const RESET_CONTACT_REQUEST_ERRORS = 'RESET_CONTACT_REQUEST_ERRORS';
export const GET_ALL_CONTACT_REQUESTS = 'GET_ALL_CONTACT_REQUESTS';
export const GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST';
export const CREATE_CONTACT_REQUEST = 'CREATE_CONTACT_REQUEST';
export const UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST';

export const redux_contactRequestActionStarts = () => ({
  type: CONTACT_REQUEST_ACTION_STARTS,
});

export const redux_contactRequestActionErrors = (error: string) => ({
  type: CONTACT_REQUEST_ACTION_ERRORS,
  payload: error,
});

export const redux_resetContactRequestErrors = () => ({
  type: RESET_CONTACT_REQUEST_ERRORS,
});

export const redux_getAllContactRequests = (contactRequests: ContactRequest[]) => ({
  type: GET_ALL_CONTACT_REQUESTS,
  payload: contactRequests,
});

export const redux_getContactRequest = (contactRequest: ContactRequest) => ({
  type: GET_CONTACT_REQUEST,
  payload: contactRequest,
});

export const redux_createContactRequest = (contactRequest: ContactRequest) => ({
  type: CREATE_CONTACT_REQUEST,
  payload: contactRequest,
});

export const redux_updateContactRequest = (contactRequest: ContactRequest) => ({
  type: UPDATE_CONTACT_REQUEST,
  payload: contactRequest,
}); 